import { Row } from '@tanstack/react-table';
import { SeasonalRule } from 'models/seasonality/SeasonalRule';
import usePropertySettingsInitData from 'pages/property/usePropertySettingsInitData';
import { useTranslation } from 'react-i18next';
import {
  AppliedCellContentWrapper,
  CheckFillCircleIconStyled,
  XCircleFillIconStyled,
} from '../../PropertySettingsSeasonalityTab.styles';

const AppliedCell = ({ row }: { row: Row<SeasonalRule> }) => {
  const { property } = usePropertySettingsInitData();
  const { metadata } = row.original;
  const { t } = useTranslation();

  const isApplied =
    metadata?.appliesToAllProperties ||
    metadata?.propertiesThatAppliesTo?.some((p) => p.uid === property?.uid);

  return (
    <div>
      {isApplied ? (
        <AppliedCellContentWrapper>
          <span data-testid="applied-text">
            {t('pageProperty.seasonality.table.appliedCell.applied')}
          </span>
          <CheckFillCircleIconStyled data-testid="applied-check-icon" />
        </AppliedCellContentWrapper>
      ) : (
        <AppliedCellContentWrapper>
          <span data-testid="not-applied-text">
            {t('pageProperty.seasonality.table.appliedCell.notApplied')}
          </span>
          <XCircleFillIconStyled data-testid="applied-x-icon" />
        </AppliedCellContentWrapper>
      )}
    </div>
  );
};

export default AppliedCell;
